import { IDefaultShopConfig } from '../shopConfig/types';

export enum DefaultShopTypes {
  LOAD_REQUEST = '@defaultShop/LOAD_REQUEST',
  LOAD_SUCCESS = '@defaultShop/LOAD_SUCCESS',
  LOAD_FAILURE = '@defaultShop/LOAD_FAILURE',
}

export interface IDefaultShopState {
  readonly error: boolean;
  readonly loading: boolean;
  readonly address: IDefaultShopConfig;
}
